/* RESPONSIBLE TEAM: team-ai-agent */

export interface FinSdrRoutingWorkflowSummaryWireFormat {
  id: string;
  title: string;
}

export default class FinSdrRoutingWorkflowSummary {
  readonly id: string;
  readonly title: string;

  constructor(id: string, title: string) {
    this.id = id;
    this.title = title;
  }

  static deserialize(json: FinSdrRoutingWorkflowSummaryWireFormat): FinSdrRoutingWorkflowSummary {
    return new FinSdrRoutingWorkflowSummary(json.id, json.title);
  }
}
